import { StudentShortLink as StudentShortLinkItem } from '@airreading/common/data';

import { StudentShortLink } from './student-short-link';

interface StudentShortLinksProps {
  shortLinks?: StudentShortLinkItem[] | null;
  shortCode?: string | null;
}

export const StudentShortLinks = ({ shortLinks, shortCode }: StudentShortLinksProps) => {
  const source: StudentShortLinkItem[] =
    shortLinks && shortLinks.length > 0
      ? shortLinks
      : shortCode
        ? [{ shortCode, isActive: true, isPaused: false }]
        : [];

  const seen = new Set<string>();
  const activeLinks: StudentShortLinkItem[] = [];
  const inactiveLinks: StudentShortLinkItem[] = [];

  for (const link of source) {
    if (seen.has(link.shortCode)) {
      continue;
    }
    seen.add(link.shortCode);

    if (link.isActive && !link.isPaused) {
      activeLinks.push(link);
    } else {
      inactiveLinks.push(link);
    }
  }

  const shortLinkHistory = [...activeLinks, ...inactiveLinks];
  if (shortLinkHistory.length === 0) {
    return <span>-</span>;
  }

  const activeShortLink = activeLinks[0] ?? null;
  const deactivatedShortLinks = inactiveLinks;

  return (
    <>
      {activeShortLink ? (
        <StudentShortLink shortCode={activeShortLink.shortCode} fullLink isActive />
      ) : (
        <p className="text-sm text-gray-500">No active link</p>
      )}
      {deactivatedShortLinks.length > 0 && (
        <div className="space-y-2">
          {deactivatedShortLinks.map((shortLink) => (
            <div key={shortLink.shortCode}>
              <StudentShortLink shortCode={shortLink.shortCode} fullLink isActive={false} />
            </div>
          ))}
        </div>
      )}
    </>
  );
};
